import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import BenchmarkBoard from './BenchmarkBoard';

import {
    updateLeftBenchmarks,
    updateRightBenchmarks,
    getScoreData,
    updateApiParams,
    getPptData,
    getSinglePastReport,
} from '../actions';

import {
    selectScoreData,
    selectScoreDataFetched,
    selectFilters,
    selectLeftBenchmarks,
    selectRightBenchmarks,
    selectApiParams,
    selectApiCount,
    selectFiltersApplied,
    getErrorInfo,
    selectPastReport,
    selectLocalPractice,
} from '../selector';

import { getDefaultSettings } from '../../Login/selector';
import { getReport, getRawPptData } from '../../Reports/actions';
import { selectPastReports, selectReportError } from '../../Reports/selector';

const stateToProps = createStructuredSelector({
    scoreData: selectScoreData(),
    scoreDataFetched: selectScoreDataFetched(),
    filters: selectFilters(),
    leftBenchmarks: selectLeftBenchmarks(),
    rightBenchmarks: selectRightBenchmarks(),
    apiParams: selectApiParams(),
    apiLoadingCount: selectApiCount(),
    activeFilter: selectFiltersApplied(),
    errorInfo: getErrorInfo(),
    defaultSettings: getDefaultSettings(),
    pastReports: selectPastReports(),
    reportError: selectReportError(),
    singlePastReport: selectPastReport(),
    localPractice: selectLocalPractice(),
});

const dispatchToProps = {
    getScoreData,
    updateLeftBenchmarks,
    updateRightBenchmarks,
    updateApiParams,
    getPptData,
    getReport,
    getRawPptData,
    getSinglePastReport,
};

export default connect(stateToProps, dispatchToProps)(BenchmarkBoard);
